const savedFilterCalls = {
  api_saved_filters_get({ dispatch }) {
    dispatch('api_call', {
      endpoint: 'poker/saved-filters/',
      hasCancel: false,
      mutation: 'api_poker_saved_filters',
      params: {
        // TODO move this to infinite table adn add more sorting options on BE
        offset: 0,
        limit: 9999,
      },
    })
  },
  api_saved_filter_post({ dispatch }, { data, ...actionArgs }) {
    dispatch('api_call', {
      method: 'POST',
      endpoint: `poker/saved-filters/`,
      hasCancel: false,
      action: 'handleSavedFilterUpdate',
      mutation: 'api_poker_saved_filter',
      actionArgs: { ...actionArgs, data },
      data,
    })
  },
  api_saved_filter_put({ dispatch }, { id, data, ...actionArgs }) {
    dispatch('api_call', {
      method: 'PUT',
      endpoint: `poker/saved-filters/${id}/`,
      hasCancel: false,
      action: 'handleSavedFilterUpdate',
      mutation: 'api_poker_saved_filter',
      actionArgs: { ...actionArgs, id, data },
      data,
    })
  },
  api_saved_filter_delete({ dispatch }, { id, data, ...actionArgs }) {
    dispatch('api_call', {
      method: 'DELETE',
      endpoint: `poker/saved-filters/${id}/`,
      action: 'handleSavedFilterUpdate',
      mutation: 'api_poker_saved_filter',
      actionArgs: { ...actionArgs, id, data },
      data,
    })
  },
}

export default savedFilterCalls
